'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var colorPalette = require('../../../../color-palette-14d554dc.js');
var hooks_useRandomId = require('../../../../hooks/use-random-id/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var CopyIcon = function CopyIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    clipPath: "url(#clip0_1545:46655)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M11.75 5.1C12.109 5.1 12.4 5.39101 12.4 5.75V7.6H14.25C14.609 7.6 14.9 7.89101 14.9 8.25C14.9 8.60898 14.609 8.9 14.25 8.9L12.4 8.9V10.75C12.4 11.109 12.109 11.4 11.75 11.4C11.391 11.4 11.1 11.109 11.1 10.75V8.9H9.24998C8.89099 8.9 8.59998 8.60898 8.59998 8.25C8.59998 7.89101 8.89099 7.6 9.24998 7.6H11.1V5.75C11.1 5.39101 11.391 5.1 11.75 5.1Z",
    fill: colorPalette.CHARCOAL_100
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.25C5 2.2835 5.7835 1.5 6.75 1.5H16.75C17.7165 1.5 18.5 2.2835 18.5 3.25V13.25C18.5 14.2165 17.7165 15 16.75 15H15V16.75C15 17.7165 14.2165 18.5 13.25 18.5H3.25C2.2835 18.5 1.5 17.7165 1.5 16.75V6.75C1.5 5.7835 2.2835 5 3.25 5H5V3.25ZM6.75 15H13.5V16.75C13.5 16.8881 13.3881 17 13.25 17H3.25C3.11193 17 3 16.8881 3 16.75V6.75C3 6.61193 3.11193 6.5 3.25 6.5H5V13.25C5 14.2165 5.7835 15 6.75 15ZM6.75 3C6.61193 3 6.5 3.11193 6.5 3.25V13.25C6.5 13.3881 6.61193 13.5 6.75 13.5H16.75C16.8881 13.5 17 13.3881 17 13.25V3.25C17 3.11193 16.8881 3 16.75 3H6.75Z",
    fill: colorPalette.CHARCOAL_100
  })), /*#__PURE__*/React__default['default'].createElement("defs", null, /*#__PURE__*/React__default['default'].createElement("clipPath", {
    id: hooks_useRandomId.useRandomId('clip')
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    width: "17",
    height: "17",
    transform: "translate(1.5 1.5)"
  }))));
};

exports.CopyIcon = CopyIcon;
//# sourceMappingURL=index.js.map
